import { createI18n } from 'vue-i18n';
import en from './en.json';
import nl from './nl.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';
import tr from './tr.json';
import be from './be.json';

export const i18n = createI18n({
  legacy: false,
  locale: navigator.language,
  fallbackLocale: 'en-GB',
  globalInjection: true,
  messages: {
    ['en']: en,
    ['en-NL']: en,
    ['en-GB']: en,
    ['en-US']: en,
    ['nl-NL']: nl,
    ['nl']: nl,
    ['fr']: fr,
    ['fr-FR']: fr,
    ['fr-BE']: fr,
    ['nl-BE']: be,
    ['de']: de,
    ['de-DE']: de,
    ['es']: es,
    ['es-ES']: es,
    ['tr']: tr,
    ['tr-TR']: tr
  }
});
